export default __webpack_public_path__ + "static/media/Video_3.27f2108c.mp4";